import { gql } from '@apollo/client'
import { TrackChangeFragment } from '../fragments/trackChange.fragment'

export const CreateTrackTipComment = gql`
    mutation createTrackChangeComment($input: CreateTrackChangeCommentInput!) {
        createTrackChangeComment(input: $input) {
            id
            comment
            userId
            createdDate
            updatedDate
            trackChangeId
            userProfileInfo {
                firstName
                lastName
                imageUrl
            }
        }
    }
`

export const DeleteTrackTipComment = gql`
    mutation deleteTrackChangeComment($input: DeleteTrackChangeCommentInput!) {
        deleteTrackChangeComment(input: $input)
    }
`

export const UpdateTrackTipComment = gql`
    mutation updateTrackChangeComment($input: UpdateTrackChangeCommentInput!) {
        updateTrackChangeComment(input: $input) {
            id
            updatedDate
            comment
            userId
            trackChangeId
        }
    }
`

export const AcceptTrackedChange = gql`
    mutation acceptTrackedChange(
        $input: AcceptTrackChangeInput!
        $includeProductTypeInFamilyTrackChanges: Boolean
    ) {
        acceptTrackChange(
            input: $input
            includeProductTypeInFamilyTrackChanges: $includeProductTypeInFamilyTrackChanges
        ) {
            ...trackChangeFragment
        }
    }
    ${TrackChangeFragment}
`
export const RejectTrackedChange = gql`
    mutation rejectTrackedChange(
        $input: RejectTrackChangeInput!
        $includeProductTypeInFamilyTrackChanges: Boolean
    ) {
        rejectTrackChange(
            input: $input
            includeProductTypeInFamilyTrackChanges: $includeProductTypeInFamilyTrackChanges
        ) {
            ...trackChangeFragment
        }
    }
    ${TrackChangeFragment}
`

export const AcceptAllTrackedChange = gql`
    mutation acceptAllTrackChanges(
        $input: AcceptAllTrackChangesInput!
        $includeProductTypeInFamilyTrackChanges: Boolean
    ) {
        acceptAllTrackChanges(
            input: $input
            includeProductTypeInFamilyTrackChanges: $includeProductTypeInFamilyTrackChanges
        ) {
            ...trackChangeFragment
        }
    }
    ${TrackChangeFragment}
`

export const RejectAllTrackedChange = gql`
    mutation rejectAllTrackChanges(
        $input: RejectAllTrackChangesInput!
        $includeProductTypeInFamilyTrackChanges: Boolean
    ) {
        rejectAllTrackChanges(
            input: $input
            includeProductTypeInFamilyTrackChanges: $includeProductTypeInFamilyTrackChanges
        ) {
            ...trackChangeFragment
        }
    }
    ${TrackChangeFragment}
`
